import React, { useState, useEffect } from "react";
import "../../App.css";
import { BaseButtons, FallingLeaf } from "../atoms";
import useWindowDimensions from "../get-diemensions/UseWindowDiemensions";
import { BlackAndWhite } from "../../themes/Colors";

const OptionLandingPage = ({
  onLoginClick,
  display,
  onABoutClick,
  displayButtons,
  onRegClick,
}) => {
  const { width, height } = useWindowDimensions();
  const [fall, setFall] = useState(false);
  const [fallinGroup, setFallinGroup] = useState(false);

  useEffect(() => {
    if (fall) {
      setTimeout(() => {
        setFall(false);
      }, 10000);
    } else {
      setFall(true);
      setFallinGroup(true);
    }
  }, [fall]);

  return (
    <div
      style={{
        height: display ? 0 : height <= 600 ? height + 80 : height + 20,
        width: width,
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        transition: "all 0.5s",
        overflow: "hidden",
        position: "relative",
      }}
    >
      <div
        style={{
          height: 400,
          width: 400,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        {/* <animated.div
          style={{
            ...styles,
          }}
        > */}
        <img
          src={require("../../images/rooftopLogo/RoofTopLogo5122.png")}
          className="App-logo"
          alt="logo"
          style={{ height: width > 899 ? 212 : 100 }}
        />
        {/* </animated.div> */}
      </div>
      <div
        style={{
          width: width,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          flexDirection: "column",
          overflow: "hidden",
          height: displayButtons ? 150 : 0,
          transition: "height 0.5s",
        }}
      >
        {/* <BaseButtons
          width={width > 899 ? "40%" : "55%"}
          label={"WELCOME"}
          onClick={onABoutClick}
          height={50}
          size={width > 899 ? "20%" : "55%"}
        /> */}
        <BaseButtons
          width={width > 899 ? "40%" : "55%"}
          label={"LOGIN"}
          onClick={onLoginClick}
          height={50}
          size={width > 899 ? "20%" : "55%"}
          fontWeight={"bold"}
          fontSize={20}
          marginTop={-0.1}
          mini={true}
        />
        <BaseButtons
          width={width > 899 ? "40%" : "55%"}
          label={"REGISTER "}
          onClick={onRegClick}
          height={50}
          size={width > 899 ? "20%" : "55%"}
          fontWeight={"bold"}
          fontSize={20}
          marginTop={20}
          mini={true}
        />
      </div>
    </div>
  );
};

export default OptionLandingPage;
